import { render, staticRenderFns } from "./SalesPointsView.vue?vue&type=template&id=08b3f063&"
import script from "./SalesPointsView.vue?vue&type=script&lang=js&"
export * from "./SalesPointsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports